import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { GridOffset } from "@insite/mobius/GridContainer";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(pageTitleStyles, {
    container: {
        gap: 0,
        css: css`
            > ${GridOffset} {
                width: calc(100% + 10px) !important;
            }
        `,
    },
    brandGridItem: {
        width: 12,
    },
    brandStyles: {
        logoImage: {
            css: css`
                img {
                    max-width: 150px;
                    max-height: 150px;
                }
            `,
        },
        nameText: {
            size: 14,
            weight: "normal",
        },
        nameLink: {
            css: css`
                span {
                    font-size: ${TYPOGRAPHY.size.smaller};
                    color: #3465b1;
                }
            `,
        },
    },
    titleGridItem: {
        width: 12,
    },
    titleText: {
        variant: "h2",
        css: css`
            // font-size: ${TYPOGRAPHY.size.xlargest};
            font-weight: ${TYPOGRAPHY.weight.bold};
            text-transform: capitalize;
            line-height: ${TYPOGRAPHY.size.largest};
        `,
    },
});
